/** PROTOTYPE flow step: how many spreads + name/size each -- THROWAWAY. */
import React from 'react';
import { CRC } from './moduleInputsData';
import { ProjectState, Spread, money } from './spreadSplitData';
import { newSpread, deleteSpread } from './spreadSeed';
import { SpreadSetup } from './SpreadSetup';
import { SpreadPriceState } from './useSpreadPrice';
import { spreadTotal } from './spreadRollup';

interface Props { project: ProjectState; setProject: (p: ProjectState) => void; priceStates: Record<string, SpreadPriceState>; }

const card: React.CSSProperties = { background: '#fff', border: `1px solid ${CRC.border}`, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.04)', padding: 20 };
const stepBtn: React.CSSProperties = { width: 34, height: 34, borderRadius: 8, border: `1px solid ${CRC.border}`, background: '#fff', color: CRC.readableRed, fontSize: 18, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' };
const countBox: React.CSSProperties = { width: 64, textAlign: 'center', padding: '8px', fontFamily: 'Funnel Sans', fontSize: 16, fontWeight: 700, color: CRC.blueprintBlue, border: `1px solid ${CRC.border}`, borderRadius: 8 };
const delBtn: React.CSSProperties = { fontSize: 11.5, color: CRC.readableRed, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 };

export const StepSpreads: React.FC<Props> = ({ project, setProject, priceStates }) => {
  const count = project.spreads.length;
  const setCount = (n: number) => {
    const target = Math.max(1, Math.min(20, Math.round(n || 1)));
    let spreads = [...project.spreads];
    while (spreads.length < target) spreads.push(newSpread(spreads.length + 1));
    if (spreads.length > target) spreads = spreads.slice(0, target);
    setProject({ ...project, spreads });
  };
  const patch = (id: string, p: Partial<Spread>) =>
    setProject({ ...project, spreads: project.spreads.map((s) => (s.id === id ? { ...s, ...p } : s)) });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={card}>
        <div style={{ fontFamily: 'Funnel Sans', fontSize: 15, fontWeight: 600, color: CRC.blueprintBlue }}>How many spreads?</div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
          <button aria-label="Fewer spreads" onClick={() => setCount(count - 1)} style={stepBtn}>-</button>
          <input title="Spread count" type="number" value={count} onChange={(e) => setCount(Number(e.target.value))} style={countBox} />
          <button aria-label="More spreads" onClick={() => setCount(count + 1)} style={stepBtn}>+</button>
          <span style={{ fontSize: 12, color: CRC.heritageGrey, marginLeft: 6 }}>Set the number of spreads, then name and size each below. Each spread is its own mini-proposal.</span>
        </div>
      </div>

      {project.spreads.map((s) => {
        const t = spreadTotal(priceStates[s.id]);
        return (
          <div key={s.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <div style={{ fontFamily: 'Funnel Sans', fontSize: 13, fontWeight: 600, color: CRC.blueprintBlue }}>{s.name}</div>
              <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                <span style={{ fontFamily: 'Funnel Sans', fontSize: 14, fontWeight: 700, color: CRC.readableRed }}>{t == null ? '…' : money(t)}</span>
                {count > 1 && <button onClick={() => setProject(deleteSpread(project, s.id))} style={delBtn}>Delete</button>}
              </div>
            </div>
            <SpreadSetup spread={s} patch={(p) => patch(s.id, p)} />
          </div>
        );
      })}
    </div>
  );
};
